import { getCloudinaryFullPath } from "../../utils";

// Shared with Royal Mahal: names from the invite URL and the Jain check.
export { coupleNames, isJainInvite } from "../RoyalMahal/helpers";

/*
 * The hero illustrations dropped into src/images/rang-utsav are picked up automatically
 * (see the README there); a missing one gives null. Only hero-illustration.* and
 * hero-illustration-south-indian.* are matched, so the folder's other images aren't pulled
 * into the build. When the compressed WebP sits beside the original PNG, the WebP is the one used.
 */
const context = require.context("../../images/rang-utsav", false, /^\.\/hero-illustration(-south-indian)?\.(webp|jpe?g|png)$/i);
const heroFile = (name) => {
  const file = ["webp", "png", "jpg", "jpeg"]
    .map((ext) => context.keys().find((key) => key.toLowerCase() === `./${name}.${ext}`))
    .find(Boolean);
  return file ? context(file) : null;
};
const HERO_ILLUSTRATION = heroFile("hero-illustration");
// The couple in South Indian wedding clothes, for an invite with `isSouthIndian`
const HERO_ILLUSTRATION_SOUTH_INDIAN = heroFile("hero-illustration-south-indian");

/** A South Indian wedding: the invite's `isSouthIndian` flag from the API (true or "true"). */
export const isSouthIndianInvite = (invite) => invite?.isSouthIndian === true || invite?.isSouthIndian === "true";

/**
 * The Ganesh chant under the Ganesh emblem, in every theme: "Shree Ganeshaya Namaha" for a
 * South Indian wedding (isSouthIndianInvite), "Shree Ganeshay Namah" otherwise.
 */
export const ganeshChant = (invite) =>
  isSouthIndianInvite(invite) ? "|| Shree Ganeshaya Namaha ||" : "|| Shree Ganeshay Namah ||";

const fullUrl = (path) => (/^(https?:)?\/\/|^data:|^blob:/.test(path) ? path : getCloudinaryFullPath(path));

/**
 * The illustration under the first page's flower arch (it then flies to the couple page):
 * the invite's own `heroIllustration` when it has one; otherwise, for a South Indian wedding,
 * src/images/rang-utsav/hero-illustration-south-indian.*; otherwise hero-illustration.*;
 * otherwise null.
 */
export const heroIllustration = (invite) => {
  const own = invite?.heroIllustration;
  if (typeof own === "string" && own.trim()) return fullUrl(own.trim());
  if (isSouthIndianInvite(invite) && HERO_ILLUSTRATION_SOUTH_INDIAN) return HERO_ILLUSTRATION_SOUTH_INDIAN;
  return HERO_ILLUSTRATION;
};
